/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Aside_ActionInputs */

const en_auth_signup_aside_action = /** @type {(inputs: Auth_Signup_Aside_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pl_auth_signup_aside_action = /** @type {(inputs: Auth_Signup_Aside_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Signup_Aside_ActionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_aside_action = /** @type {((inputs?: Auth_Signup_Aside_ActionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Aside_ActionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_aside_action(inputs)
	return en_auth_signup_aside_action(inputs)
});